<template>
    <aside
        class="relative inline-flex flex-col items-center flex-shrink-0 min-h-screen p-4 space-y-6 bg-gray-800 shadow w-60">
        <div class="float-left w-full">
            <img src="/logo.svg" alt="floret College" class="w-36">
        </div>
        <nav class="inline-flex flex-col w-full space-y-4 ">
            <inertia-link :href="branch_id?`${route('dashboard')}?branch=${branch_id}`:route('dashboard')"
                          class="flex items-center py-2 pl-2 pr-6 rounded-lg cursor-pointer" :class="
                    [route().current('dashboard') ? 'bg-white text-gray-800' : 'hover:bg-white hover:text-gray-800 text-white text-white']"
                          @click="selected = index">
                <svg xmlns="http://www.w3.org/2000/svg" v-if="!route().current('dashboard')" class="w-8 h-8 p-1 mr-4"
                     fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" v-if="route().current('dashboard')" class="w-8 h-8 p-1 mr-4"
                     viewBox="0 0 20 20" fill="currentColor">
                    <path
                        d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"/>
                </svg>
                <span v-html="'Dashboard'" class="font-medium select-none"></span>
            </inertia-link>
            <inertia-link :href="route('administrative.branch.list')"
                          class="flex items-center py-2 pl-2 pr-6 rounded-lg cursor-pointer"
                          :class="[route().current('administrative.*') ? 'bg-white text-gray-800' : 'hover:bg-white hover:text-gray-800 text-white']"
                          v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Branch' || permission.name === 'Edit Branch' || permission.name === 'View Branch' || permission.name === 'Create User' || permission.name === 'Edit User' || permission.name === 'View User' || permission.name === 'Create Faculty' || permission.name === 'Edit Faculty' || permission.name === 'View Faculty')">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4"
                     v-if="!route().current('administrative.*')" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4"
                     v-if="route().current('administrative.*')" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                          clip-rule="evenodd"/>
                </svg>
                <span v-html="'Administrative'" class="font-medium select-none"></span>
            </inertia-link>

            <inertia-link :href="route('academic.duration.list')"
                          class="flex items-center py-2 pl-2 pr-6 rounded-lg cursor-pointer"
                          :class="[route().current('academic.*') ? 'bg-white text-gray-800' : 'hover:bg-white hover:text-gray-800 text-white']"
                          v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Duration' || permission.name === 'Edit Duration' || permission.name === 'View Duration' || permission.name === 'Create Semester' || permission.name === 'Edit Semester' || permission.name === 'View Semester' || permission.name === 'Create Course Type' || permission.name === 'Edit Course Type' || permission.name === 'View Course Type' || permission.name === 'Create Course' || permission.name === 'Edit Course' || permission.name === 'View Course' || permission.name === 'Create Subject' || permission.name === 'Edit Subject' || permission.name === 'View Subject' || permission.name === 'Create Course Year' || permission.name === 'Edit Course Year' || permission.name === 'View Course Year')">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="!route().current('academic.*')"
                     fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path d="M12 14l9-5-9-5-9 5 9 5z"/>
                    <path
                        d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"/>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="route().current('academic.*')"
                     viewBox="0 0 20 20" fill="currentColor">
                    <path
                        d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"/>
                </svg>
                <span v-html="'Academic'" class="font-medium select-none"></span>
            </inertia-link>

            <inertia-link :href="route('placement.company.list')"
                          class="flex items-center py-2 pl-2 pr-6 rounded-lg cursor-pointer"
                          :class="[route().current('placement.*') ? 'bg-white text-gray-800' : 'hover:bg-white hover:text-gray-800 text-white']"
                          v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Company' || permission.name === 'Edit Company' || permission.name === 'View Company' || permission.name === 'Create Job' || permission.name === 'Edit Job' || permission.name === 'View Job')">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="!route().current('placement.*')"
                     fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="route().current('placement.*')"
                     viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                          d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                          clip-rule="evenodd"/>
                </svg>
                <span v-html="'Placements'" class="font-medium select-none"></span>
            </inertia-link>

            <inertia-link :href="route('heads.contact.list')"
                          class="flex items-center py-2 pl-2 pr-6 rounded-lg cursor-pointer"
                          :class="[route().current('heads.*') ? 'bg-white text-gray-800' : 'hover:bg-white hover:text-gray-800 text-white']"
                          v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Contact' || permission.name === 'Edit Contact' || permission.name === 'View Contact' || permission.name === 'Create Application Letter' || permission.name === 'Edit Application Letter' || permission.name === 'View Application Letter' || permission.name === 'Create Payment Mode' || permission.name === 'Edit Payment Mode' || permission.name === 'View Payment Mode' || permission.name === 'Create Expense Type' || permission.name === 'Edit Expense Type' || permission.name === 'View Expense Type' || permission.name === 'Create Role' || permission.name === 'Edit Role' || permission.name === 'View Role')">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="!route().current('heads.*')"
                     fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="route().current('heads.*')"
                     viewBox="0 0 20 20" fill="currentColor">
                    <path
                        d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"/>
                </svg>
                <span v-html="'Heads'" class="font-medium select-none"></span>
            </inertia-link>

            <inertia-link :href="route('notice.branch.list')"
                          class="flex items-center py-2 pl-2 pr-6 rounded-lg cursor-pointer"
                          :class="[route().current('notice.*') ? 'bg-white text-gray-800' : 'hover:bg-white hover:text-gray-800 text-white']"
                          v-if="this.$page.props.auth.user.role.permissions.some(permission => permission.name === 'Create Notice' || permission.name === 'Edit Notice' || permission.name === 'View Notice')">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="!route().current('notice.*')"
                     fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="route().current('notice.*')"
                     viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clip-rule="evenodd"/>
                </svg>
                <span v-html="'Notice'" class="font-medium select-none"></span>
            </inertia-link>

            <inertia-link :href="route('term.index')"
                          class="flex items-center py-2 pl-2 pr-6 rounded-lg cursor-pointer"
                          :class="[route().current('term.*') ? 'bg-white text-gray-800' : 'hover:bg-white hover:text-gray-800 text-white']"
                          v-if="this.$page.props.auth.user.role.permissions.some(permission => permission.name === 'Create Term' || permission.name === 'Edit Term' || permission.name === 'View Term')">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     class="w-8 h-8 p-1 mr-4" v-if="!route().current('term.*')" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" stroke-width="1.5"
                     class="w-8 h-8 p-1 mr-4" v-if="route().current('term.*')" stroke="white">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"/>
                </svg>

                <span v-html="'T&C'" class="font-medium select-none"></span>
            </inertia-link>

            <inertia-link :href="route('others.resource.list')"
                          class="flex items-center py-2 pl-2 pr-6 rounded-lg cursor-pointer"
                          :class="[route().current('others.*') ? 'bg-white text-gray-800' : 'hover:bg-white hover:text-gray-800 text-white']"
                          v-if="isAdmin()">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="!route().current('others.*')"
                     fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M5 5h14M5 12h14M5 19h14M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1z"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="route().current('others.*')"
                     viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                          d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm1 3a1 1 0 000 2h10a1 1 0 100-2H5zm0 4a1 1 0 000 2h10a1 1 0 100-2H5zm0 4a1 1 0 100 2h6a1 1 0 100-2H5z"
                          clip-rule="evenodd"/>
                </svg>
                <span v-html="'Others'" class="font-medium select-none"></span>
            </inertia-link>

            <inertia-link :href="internalHref()"
                          class="flex items-center py-2 pl-2 pr-6 rounded-lg cursor-pointer"
                          :class="[route().current('internal.*') ? 'bg-white text-gray-800' : 'hover:bg-white hover:text-gray-800 text-white']"
                          v-if="hasInternalAccess()">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="!route().current('internal.*')"
                     fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="route().current('internal.*')"
                     viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                          d="M10.496 2.132a1 1 0 00-.992 0l-7 4A1 1 0 003 8v7a1 1 0 100 2h14a1 1 0 100-2V8a1 1 0 00.496-1.868l-7-4zM6 9a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm3 1a1 1 0 012 0v3a1 1 0 11-2 0v-3zm5-1a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1z"
                          clip-rule="evenodd"/>
                </svg>
                <span v-html="'Internal'" class="font-medium select-none"></span>
            </inertia-link>

            <inertia-link
                :href="route('report.academic',branch_id)"
                v-if="hasRole('View Report')"
                class="flex items-center py-2 pl-2 pr-6 rounded-lg cursor-pointer"
                :class="[route().current('report.*') ? 'bg-white text-gray-800' : 'hover:bg-white hover:text-gray-800 text-white']"
            >
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="!route().current('report.*')"
                     fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
                </svg>

                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 p-1 mr-4" v-if="route().current('report.*')"
                     viewBox="0 0 24 24" fill="currentColor">
                    <path fill-rule="evenodd"
                          d="M5.625 1.5H9a3.75 3.75 0 013.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 013.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 01-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875zM9.75 17.25a.75.75 0 00-1.5 0V18a.75.75 0 001.5 0v-.75zm2.25-3a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75zm3.75-1.5a.75.75 0 00-1.5 0V18a.75.75 0 001.5 0v-5.25z"
                          clip-rule="evenodd"/>
                    <path
                        d="M14.25 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0016.5 7.5h-1.875a.375.375 0 01-.375-.375V5.25z"/>
                </svg>

                <span v-html="'Reports'" class="font-medium select-none"></span>
            </inertia-link>
        </nav>
    </aside>
</template>
<script>
import {hasRole} from "../../Utils/checkPermission";
import {usePage} from "@inertiajs/inertia-vue3";

export default {
    methods: {
        hasRole,
        isAdmin() {
            const role = this.$page.props.auth.user.role;

            return role?.type === 'super' || role?.name === 'Super Admin';
        },
        internalPermissions() {
            return [
                'View Lead',
                'View Enquiry',
                'View Admission',
                'Create Schedule',
                'Edit Schedule',
                'View Schedule',
                'Create Branch Course',
                'Edit Branch Course',
                'View Branch Course',
                'Create Workshop',
                'Edit Workshop',
                'View Workshop',
                'View Bulk IDS',
                'View University Marking',
            ];
        },
        hasInternalPermission() {
            const permissions = this.$page.props.auth.user.role.permissions ?? [];

            return permissions.some(permission => this.internalPermissions().includes(permission.name));
        },
        hasBranchAccess() {
            return Boolean(this.$page.props.auth.user.branch_id) || this.isAdmin();
        },
        hasInternalAccess() {
            return this.hasInternalPermission() || this.hasBranchAccess();
        },
        internalHref() {
            if (! this.hasInternalPermission() && this.hasBranchAccess()) {
                return route('internal.resource.list', this.branch_id);
            }

            return route('internal.lead.list', this.branch_id);
        },
    },
    props: ['isEnlarge'],
    data() {
        return {
            selected: 0,
            branch_id: localStorage.branchId ?? usePage().props.value.branches[0] ?? 1
        }
    },
    computed: {
        branches() {
            return usePage().props.value.branches;
        }
    },
}
</script>
